// app/components/Header.tsx
'use client';
import { useEffect, useState } from 'react';
import Image from 'next/image';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 230); // Berubah setelah scroll 230px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-gradient-to-r from-orange-400 to-orange-600 shadow-orange-200'
      }  px-6 py-3 sticky top-0 z-52 transition-all duration-500`}
    >
      <div className="flex items-center justify-between max-w-md mx-auto">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <div className="relative">
            {/* Logo Image - 2 tipe berdasarkan scroll state */}
            <div className="relative">
              <Image
                src={isScrolled ? '/assets/img/logo/logo-warna.png' : '/assets/img/logo/logo-putih.png'}
                alt="Logo"
                width={100}
                height={100}
                className="object-contain transition-opacity duration-500"
                priority
              />
            </div>            
          </div>
        </div>

        {/* Versi Uji Coba Text */}
        <div className="text-right">
          <span 
            className={`${
              isScrolled 
                ? 'text-orange-600' 
                : 'text-white'
            } font-medium text-sm transition-colors duration-500`}
          >
            Versi Uji Coba
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
